import axios from 'axios';

export type InviteTeamBannerDismissal = {
  dismissedAt: string | null;
};

// flipdish-app BFF. Set via VITE_APP_BFF_BASE (production gateway or local SST).
const APP_API_BASE = process.env.VITE_APP_BFF_BASE ?? '';

// Without a base URL the request would resolve against the portal's own origin,
// so callers skip it entirely rather than 404 against ourselves.
export const isAppBffConfigured = Boolean(APP_API_BASE);

const DISMISSAL_URL = `${APP_API_BASE}/me/invite-users-banner-dismissal`;

export async function getInviteTeamBannerDismissal(): Promise<InviteTeamBannerDismissal> {
  const { data } = await axios.get<InviteTeamBannerDismissal>(DISMISSAL_URL, {
    withCredentials: true,
  });
  return data;
}

export async function dismissInviteTeamBanner(): Promise<void> {
  await axios.put(DISMISSAL_URL, undefined, { withCredentials: true });
}
